// namespace (소문자)
export const NAMESPACE = 'estimate';
//actions
export const CREATE_ESTIMATION = 'CREATE_ESTIMATION';
export const FETCH_ESTIMATION = 'FETCH_ESTIMATION';
export const UPDATE_ESTIMATION = 'UPDATE_ESTIMATION';
export const DELETE_ESTIMATION = 'DELETE_ESTIMATION';
export const FETCH_ESTIMATION_LIST = 'FETCH_ESTIMATION_LIST';
export const FETCH_AUTO_ESTIMATION_IN_PROGRESS =
  'FETCH_AUTO_ESTIMATION_IN_PROGRESS';
export const FETCH_LATELY_ESTIMATION = 'FETCH_LATELY_ESTIMATION';
export const FETCH_QUOTATION_ME = 'FETCH_QUOTATION_ME';

export const CREATE_QUOTATION = 'CREATE_QUOTATION';
export const FETCH_QUOTATION = 'FETCH_QUOTATION';
export const FETCH_QUOTATION_LIST = 'FETCH_QUOTATION_LIST';
export const PUSH_QUOTATION = 'PUSH_QUOTATION';

//mutations
export const SET_ESTIMATION = 'SET_ESTIMATION';
export const SET_ESTIMATION_LIST = 'SET_ESTIMATION_LIST';
export const SET_AUTO_ESTIMATION = 'SET_AUTO_ESTIMATION';
export const SET_QUOTATION = 'SET_QUOTATION';
export const SET_QUOTATION_LIST = 'SET_QUOTATION_LIST';
export const SET_ESTIMATION_REQUEST_AT = 'SET_ESTIMATION_REQUEST_AT';

//state
export const SET_ESTIMATION_MODEL = 'SET_ESTIMATION_MODEL';
export const ESTIMATION_MODEL_RESET_STATE = 'ESTIMATION_MODEL_RESET_STATE';
export const ESTIMATION_LIST_RESET_STATE = 'ESTIMATION_LIST_RESET_STATE';
export const ESTIMATION_ALL_RESET_STATE = 'ESTIMATION_LIST_RESET_STATE';
export const QUOTATION_RESET_STATE = 'QUOTATION_RESET_STATE';
export const QUOTATION_LIST_RESET_STATE = 'QUOTATION_LIST_RESET_STATE';

//getters
export const ESTIMATION = 'ESTIMATION';
export const ESTIMATION_LIST = 'ESTIMATION_LIST';
export const AUTO_ESTIMATION = 'AUTO_ESTIMATION';
export const QUOTATION = 'QUOTATION';
export const QUOTATION_LIST = 'QUOTATION_LIST';
export const ESTIMATION_MODEL = 'ESTIMATION_MODEL';

export const getName = name => `${NAMESPACE}/${name}`;
export const ROOT_SET_ESTIMATION_REQUEST_AT = getName(
  SET_ESTIMATION_REQUEST_AT,
);
